import React, { Fragment } from 'react'
import Common from '../../utils/common';

export default class ScriptInit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            host:[]
        }


        var param = {};        
        if (window.productEnv)//test
        {
            this.state.build = Common.getPage('afterViewHome', param);
        }
    }
    render() {
        return (
            <script src="https://www.google.com/recaptcha/api.js" async></script>
        )

    }

}

